// @ts-expect-error moved old js implementation
VCOM.navigationList = VCOM.navigationList || null;
// @ts-expect-error moved old js implementation
VCOM.portletInitCallback = () => ({});
// @ts-expect-error moved old js implementation
VCOM.acl = null;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const VcomProvider = VCOM;
export default VcomProvider;
